export class Local {
    ativo: boolean;
    id: number;
    descricao: string;
    tipo: number;
    nome: string;
    enderecoId: number;
}

export class LocalCombustivel {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    preco: number;
    combustivelId: number;
    localId: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/locais/shared/local.model.ts
 **/